var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M19.762 10.187c0-.82-.067-1.417-.21-2.037h-9.357v3.698h5.492c-.11.92-.709 2.303-2.038 3.233l-.018.124 2.958 2.292.205.02c1.883-1.738 2.968-4.296 2.968-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M10.195 19.931c2.69 0 4.95-.886 6.6-2.414l-3.146-2.436c-.841.587-1.97.997-3.454.997-2.636 0-4.872-1.739-5.67-4.141l-.117.01-3.076 2.38-.04.112a9.96 9.96 0 0 0 8.903 5.492"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M4.525 11.937a6.1 6.1 0 0 1-.332-1.971c0-.687.122-1.351.321-1.971l-.005-.132-3.115-2.42-.102.05A10 10 0 0 0 .229 9.965c0 1.605.388 3.122 1.063 4.473z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M10.195 3.853c1.871 0 3.133.809 3.853 1.484l2.812-2.746C15.133.985 12.885 0 10.196 0a9.96 9.96 0 0 0-8.903 5.492l3.222 2.503c.809-2.403 3.045-4.142 5.68-4.142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgGoogle;